import PropTypes from 'prop-types';

export const catalogueCategoryType = PropTypes.shape({
  category: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  imagePath: PropTypes.string.isRequired,
  reference: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
});
